// Share a note with colleagues: the shared people picker
// (components/SharePeopleDialog) wired to the notes API. Recipients can edit
// the note's title and body; every edit is logged in the note's history.
import notesApi, { type NoteShareUser, type NoteSummary } from "../../api/notes";
import SharePeopleDialog from "../../components/SharePeopleDialog";

interface ShareNoteDialogProps {
  note: NoteSummary;
  /** Called with the saved recipient list so the card/editor can update. */
  onSaved: (noteId: string, sharedWith: NoteShareUser[]) => void;
  onClose: () => void;
}

export default function ShareNoteDialog({ note, onSaved, onClose }: ShareNoteDialogProps) {
  return (
    <SharePeopleDialog
      noun="note"
      itemTitle={note.title || "Untitled note"}
      ownerId={note.owner_id}
      initialUserIds={note.shared_with.map((s) => s.user_id)}
      accessNote="people you pick can read and edit it; you'll see who changed what in its history."
      onSave={async (userIds) => {
        const res = await notesApi.share(note.id, userIds);
        onSaved(note.id, res.data.shared_with);
        return res.data.shared_with.length;
      }}
      onClose={onClose}
    />
  );
}
